export var GridColor;
(function (GridColor) {
    GridColor[GridColor["Positive"] = 65280] = "Positive";
    GridColor[GridColor["Negative"] = 16711680] = "Negative";
    GridColor[GridColor["Inactive"] = 12632256] = "Inactive";
})(GridColor || (GridColor = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/GridColor.ts
// module id = 2185
// module chunks = 3